import { Enum_Mindfulminute_Type, MindfulMinuteEntity } from '@/graphql/generated/graphql';
import { createUndefinedObject, pushDataLayer } from './utils';
import { GAEvent } from './events';

interface MindfulMinuteData {
  date: string;
  title: string;
  mindfulMinutetype: string;
}

export const trackMindfulMinute = (data: MindfulMinuteData) => {
  pushDataLayer<MindfulMinuteData>(GAEvent.MINDFUL_MINUTE_COMPLETED, data);
};

export const clearMindfulMinuteDataLayer = () => {
  const data = createUndefinedObject<MindfulMinuteData>();
  pushDataLayer(`clear_${GAEvent.MINDFUL_MINUTE_COMPLETED}`, data);
};

export const getMindfulMinuteTitle = (mindfulMinute: MindfulMinuteEntity) => {
  switch (mindfulMinute?.attributes?.type) {
    case Enum_Mindfulminute_Type.Breathing:
      return mindfulMinute?.attributes?.calmBreathing?.title;
    case Enum_Mindfulminute_Type.Prompt:
      return mindfulMinute?.attributes?.prompt?.title;
    case Enum_Mindfulminute_Type.Video:
      return mindfulMinute?.attributes?.video?.videoTitle;
    default:
      return '';
  }
};
